//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_threePiOver2 = 4.71238898038469;\n\
";
